import { Component, Fragment, h, Prop } from '@stencil/core';
import { Article } from '../rentware-cart-article/interfaces';
import { ShippingItem } from '../../../redux/types';
import { TotalPriceCalculation } from '../../../types/types';

@Component({
  tag: 'rentware-cart-template-articles',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareCartTemplateArticles {
  @Prop() showVariationModalForId: string;
  @Prop() showMileageModalForId: string;
  @Prop() articles?: Article[];
  @Prop() shipping?: ShippingItem;
  @Prop() onVariationSubmit;
  @Prop() onMileageOptionChange;
  @Prop() waitingArticles = [];
  @Prop() onShowVariationModalForId;
  @Prop() distanceUnitAbbreviation: string;
  @Prop() cartPriceCalculation: TotalPriceCalculation;

  get shippingArticle() {
    if (!this.shipping) {
      return null;
    }

    return {
      id: `${this.shipping.optionId}-${this.shipping.method}`,
      articleTitle: this.shipping.name,
      includedArticles: [],
      connectedArticles: [],
      itemAmount: 1,
      price: this.shipping.price,
      totalPrice: this.shipping.price,
      removable: false,
    };
  }

  render() {
    return (
      <div class="ArticlesContainer">
        {this.articles.map(article => {
          return (
            <Fragment>
              <rentware-cart-article
                key={article.key}
                article={article}
                showMileageModalForId={this.showMileageModalForId}
                onShowVariationModalForId={this.onShowVariationModalForId}
                isWaiting={this.waitingArticles.includes(article.id)}
                cartPriceCalculation={this.cartPriceCalculation}
              />

              {article.isVariation && this.showVariationModalForId === article.itemId && (
                <Fragment>
                  <rentware-spacer size="S" />

                  <rentware-variation-selection onSubmit={e => this.onVariationSubmit(e, article.id, article.itemId)} itemId={article?.itemId} />

                  <rentware-spacer size="S" />
                </Fragment>
              )}

              {this.showMileageModalForId === article.itemId && (
                <Fragment>
                  <rentware-spacer size="S" />

                  <rentware-cart-mileage
                    mileageOptions={article.availableMileageOptions}
                    quantity={article.itemAmount}
                    value={article.mileageOption?.id}
                    onValueChange={e => this.onMileageOptionChange(article.itemId, e.detail)}
                    isWaiting={this.waitingArticles.includes(article.itemId)}
                  />

                  <rentware-spacer size="S" />
                </Fragment>
              )}
            </Fragment>
          );
        })}

        {this.shipping && <rentware-cart-article key={this.shipping.optionId} article={this.shippingArticle} />}
      </div>
    );
  }
}
